import styled from 'styled-components'

export const ContainerHeaderFacialRecognition = styled.div`
  display: flex;
  flex: 1;
  row-gap: 12px;

  justify-content: space-between;
  width: 100%;

  @media (max-width: 1748px) {
    column-gap: 20px;
  }
  @media (max-width: 1558px) {
    column-gap: 10px;
  }
  @media (max-width: 1050px) {
    display: flex;
    flex-direction: column;
  }
`
